<template>
  <div class="deviceChartNew section tableloding" v-loading="isLoading" element-loading-spinner="el-icon-loading">
    <!-- {{`【chartData.category】：${chartData.category}`}} -->
    <!-- {{`【chartData.data】：${JSON.stringify(chartData.data)}`}} -->
    <!-- {{`【chartData.unitX】：${chartData.unitX}`}} -->
    <div class="section-header">
      <div class="tool">
        <!-- <span class="tiplabel">{{$t('device.timeSlot')}}</span> -->
        <span v-for="(val, key) in categories" class="category" :class="{ selected: currentCategoryKey == key }"
          :key="key" @click="currentCategoryKey = key">{{ val.label }}</span>

        <!-- 日(增加今日的快捷选择) -->
        <div class="datePreNext" v-show="currentCategoryVal.datepickerType == 'date'">
          <span class="date-icon"></span>
          <!-- 上一天 -->
          <span class="date-btn date-pre" @click="toPreDay"></span>
          <!-- 日期选择器 -->
          <!-- v-show="currentCategoryVal.datepickerType == 'date'" -->
          <el-date-picker v-model="chartDate" type="date" class="datepicker" :editable="false" :clearable="false"
            popper-class="select-date" :picker-options="pickerDayOptions" align="center" ref="dateDay"></el-date-picker>
          <!-- 下一天 -->
          <span class="date-btn date-next" @click="toNextDay"></span>
        </div>

        <!-- 月(增加今月的快捷选择) -->
        <div class="datePreNext" v-show="currentCategoryVal.datepickerType == 'month'">
          <span class="date-icon"></span>
          <!-- 上一月 -->
          <span class="date-btn date-pre" @click="toPreMonth"></span>
          <!-- 日期选择器 -->
          <!-- v-show="currentCategoryVal.datepickerType == 'month'" -->
          <el-date-picker v-model="chartDate" type="month" class="datepicker" :editable="false" :clearable="false"
            popper-class="select-date" :picker-options="pickerMonthOptions" align="center"
            ref="dateMonth"></el-date-picker>
          <!-- 下一月 -->
          <span class="date-btn date-next" @click="toNextMonth"></span>
        </div>

        <!-- 年 -->
        <div class="datePreNext" v-show="currentCategoryVal.datepickerType == 'year'">
          <span class="date-icon"></span>
          <!-- 上一年 -->
          <span class="date-btn date-pre" @click="toPreYear"></span>
          <!-- 日期选择器 -->
          <!-- v-show="currentCategoryVal.datepickerType == 'year'" -->
          <el-date-picker v-model="chartDate" type="year" class="datepicker" :editable="false" :clearable="false"
            popper-class="select-date" :picker-options="pickerYearOptions" align="center" ref="dateYear"></el-date-picker>
          <!-- 下一年 -->
          <span class="date-btn date-next" @click="toNextYear"></span>
        </div>
      </div>

      <!-- 导出设备报表(此期暂时注释) -->
      <!-- v-show="currentData" -->
      <!-- @click="exportDeviceDetail()" -->
      <!-- @click="exportPlant([deviceInfo])" -->
      <!-- <div class="exportClass">
        <button 
          type="button" 
          class="button-export"
          @click="exportPlant([deviceInfo])"
        >
          {{$t('report.Export_report')}}
          <i class="ico-download"></i>
        </button>
      </div> -->
    </div>
    <div class="section-chart">
      <div v-if="!showFlag" class="center nodata">
        <!-- <div class="nodata1">{{ $t('account.nodata') }}</div> -->
        <div class="dataspan">
          <!-- <img src="../../../../assets/img/general/Subtract.png" alt=""> -->
          <!-- <div class="dataspanTop"></div> -->
          <div class="dataspanBom">
            <p>{{ $t('account.reason') }}</p>
            <p>1.{{ $t('account.reason1') }}</p>
            <p v-if="currentCategoryVal.chartType == 'line'">2.{{ $t('account.reason3') }}</p>
            <p v-else-if="currentCategoryVal.chartType == 'bar'">2.{{ $t('account.reason2') }}</p>
            <p v-else>2.{{ $t('account.reason2') }}</p>
          </div>
        </div>
      </div>
      <!-- unit="kW" -->
      <echart-line v-if="currentCategoryVal.chartType == 'line' && !isLoading && showFlag" :category="chartData.category"
        :data="chartData.data" unit="kW" :unitX="chartData.unitX"></echart-line>
      <echart-bar v-if="currentCategoryVal.chartType == 'bar' && !isLoading && showFlag" :category="chartData.category"
        :data="chartData.data" unit="kWh" :unitX="chartData.unitX"></echart-bar>


    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import echartLine from "@/components/echartsNew/line";
import echartBar from "@/components/echartsNew/bar";
import { i18n } from '@/i18n';
// [增加导出报表]
import cookie from '@/assets/js/cookie';
import config from '@/assets/js/config';
import request from "@/assets/js/request";
import encryption from "@/assets/js/encryption";
export default {
  components: {
    echartLine,
    echartBar
  },
  data () {
    let nowYear = this.$filter.formatDate(new Date(), "yyyy");
    // 每月日期列表
    let dayList = [];
    for (let i = 1; i <= 31; i++) {
      dayList.push(this.$filter.formatNum(i, 2, "pad"));
    }
    // 每年月份列表
    let monthList = [];
    for (let i = 1; i <= 12; i++) {
      monthList.push(this.$filter.formatNum(i, 2, "pad"));
    }
    return {
      // 是否显示图表
      showFlag: false,
      categories: {
        day: {
          label: this.$t("device.day"),
          datepickerType: "date",
          chartType: "line",
          param: {
            action: "/dcs/api/auth/web/ess/device/outputPowerOneDay",
            parameter: [
              {
                name: this.$t("device.pvPower"),
                value: "PV_OUTPUT_POWER"
              },

              {
                name: this.$t("device.loadPower"),
                value: "LOAD_ACTIVE_POWER"
              },
              {
                name: this.$t("device.batteryPower"),
                value: "BATTERY_ACTIVE_POWER"
              },
              {
                name: this.$t("device.gridPower"),
                value: "GRID_ACTIVE_POWER"
              }
            ], // 图表各模块数据接口
            dateFormat: "yyyy-MM-dd", // 传参日期格式
            fields: ["detail", "ts"] // 响应数据字段
          }
        },
        month: {
          label: this.$t("device.month"),
          datepickerType: "month",
          chartType: "bar",
          param: {
            action: "/dcs/api/auth/web/ess/device/energyMonthPerDay",
            parameter: [
              {
                name: this.$t("device.generated"),
                value: "ENERGY_TODAY"
              },
              {
                name: this.$t("device.bought"),
                value: "ENERGY_TODAY_FROM_GRID",
                devcode: 2363 // 该协议下该参数被排除
              },
              {
                name: this.$t("device.sold"),
                value: "ENERGY_TODAY_TO_GRID",
                devcode: 2363
              },
              {
                name: this.$t("device.charged"),
                value: "BATTERY_ENERGY_TODAY_CHARGE",
                devcode: 2363
              },
              {
                name: this.$t("device.discharged"),
                value: "BATTERY_ENERGY_TODAY_DISCHARGE",
                devcode: 2363
              },
              {
                name: this.$t("device.used"),
                value: "LOAD_ENERGY_TODAY"
              }
            ],
            dateFormat: "yyyy-MM",
            fields: ["option", "gts"]
          },
          chartFormat: "dd",
          chartCategory: dayList // 图表x轴
        },
        year: {
          label: this.$t("device.year"),
          datepickerType: "year",
          chartType: "bar",
          param: {
            action: "/dcs/api/auth/web/ess/device/energyYearPerMonth",
            parameter: [
              {
                name: this.$t("device.generated"),
                value: "ENERGY_TOTAL"
              },
              {
                name: this.$t("device.bought"),
                value: "ENERGY_TOTAL_FROM_GRID",
                devcode: 2363
              },
              {
                name: this.$t("device.sold"),
                value: "ENERGY_TOTAL_TO_GRID",
                devcode: 2363
              },
              {
                name: this.$t("device.charged"),
                value: "BATTERY_ENERGY_TOTAL_CHARGE",
                devcode: 2363
              },
              {
                name: this.$t("device.discharged"),
                value: "BATTERY_ENERGY_TOTAL_DISCHARGE",
                devcode: 2363
              },
              {
                name: this.$t("device.used"),
                value: "LOAD_ENERGY_TOTAL"
              }
            ],
            dateFormat: "yyyy",
            fields: ["option", "gts"]
          },
          chartFormat: "MM",
          chartCategory: monthList
        },
        all: {
          label: this.$t("device.all"),
          chartType: "bar",
          param: {
            action: "/dcs/api/auth/web/ess/device/energyTotalPerYear",
            parameter: [
              {
                name: this.$t("device.generated"),
                value: "ENERGY_TOTAL"
              },
              {
                name: this.$t("device.bought"),
                value: "ENERGY_TOTAL_FROM_GRID",
                devcode: 2363
              },
              {
                name: this.$t("device.sold"),
                value: "ENERGY_TOTAL_TO_GRID",
                devcode: 2363
              },
              {
                name: this.$t("device.charged"),
                value: "BATTERY_ENERGY_TOTAL_CHARGE",
                devcode: 2363
              },
              {
                name: this.$t("device.discharged"),
                value: "BATTERY_ENERGY_TOTAL_DISCHARGE",
                devcode: 2363
              },
              {
                name: this.$t("device.used"),
                value: "LOAD_ENERGY_TOTAL"
              }
            ],
            dateFormat: null,
            fields: ["option", "gts"]
          },
          chartFormat: "yyyy",
          chartCategory: [
            nowYear - 4,
            nowYear - 3,
            nowYear - 2,
            nowYear - 1,
            nowYear - 0
          ]
        }
      },
      chartData: {
        category: [], // 数据模块
        data: [],
        unitX: ""
      }, // 图表数据
      currentCategoryKey: "day", // 当前选择时间类别
      chartDate: new Date(), // 当前所选时间
      isLoading: false, // 正在加载数据
      // 增加今日的快捷选择
      // i18n.t('device.cur_year')、cur_month、cur_day
      pickerDayOptions: {
        shortcuts: [{
          // text: `今天：
          //   ${String(new Date().getFullYear())}${i18n.t('device.year')}
          //   ${String(new Date().getMonth())}${i18n.t('device.month')}
          //   ${String(new Date().getDate())}${i18n.t('device.day')}
          // `,
          text: i18n.t('device.cur_today') + "：" +
            String(new Date().getFullYear()) + '/' +
            String(new Date().getMonth() + 1) + '/' +
            String(new Date().getDate())
          ,
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }],
        disabledDate(time) {
          return time.getTime() > Date.now(); // 设置选择今天以及今天之前的日期
        },
      },
      // 增加本月的快捷选择
      pickerMonthOptions: {
        shortcuts: [{
          text: i18n.t('device.cur_thismonth') + "：" +
            String(new Date().getFullYear()) + '/' +
            String(new Date().getMonth() + 1)
          ,
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }],
        disabledDate (time) {
          return time.getTime() >= new Date();
        }
      },
      // 增加年的快捷选择
      pickerYearOptions: {
        disabledDate (time) {
          return time.getTime() >= new Date();
        }
      },
    };
  },
  computed: {
    currentCategoryVal () {
      return this.categories[this.currentCategoryKey];
    },
    ...mapGetters({
      deviceInfo: "getDeviceInfo",
      chartStatus: 'getChartStatus'
    })
  },
  watch: {
    deviceInfo: {
      handler () {
        this.queryData();
      },
      deep: true
    },
    currentCategoryKey () {
      this.chartDate = new Date();
      // this.queryData();
    },
    chartDate () {
      this.queryData();
    }
  },
  created () {
    this.queryData();

  },
  mounted () {
    // this.getQuerySPKeyParameters()
  },
  methods: {
    //是否有日月年总数据
    // getQuerySPKeyParameters(){
    //   let param={
    //     devcode:this.deviceInfo.devcode
    //   }
    //   this.$request.get("querySPKeyParameters",param).then(res=>{
    //     console.log(res,'res');
    //     res.dat.keys.forEach(item=>{
    //       console.log(item,'item');
    //       let categories=this.categories
    //       console.log( this.categories,'this.categories');
    //       console.log( categories.day.parma.parameter,'categories.day.parma.parameter');
    //       categories.day.parma.parameter.forEach(item=>{
    //         console.log(item,'222');
    //       })
    //     })
    //   })
    // },
    // 导出单个报表
    exportPlant (paramArr) {
      // console.log("[chart-paramArr]", paramArr);
      // console.log("[chart-dateType]", this.currentCategoryVal.datepickerType);

      var PNAll = []
      // this.params
      paramArr.forEach(item => {
        PNAll.push(item.pn)
      });
      // 
      this.pnbox = PNAll
      let action, param = {
        action: 'exportCollectorsData',
        i18n: this.$lang.currentLang,
        // pns: this.params.pn,
        pns: this.pnbox.join(','),
      }
      // this.activeType
      let dateType = this.currentCategoryVal.datepickerType || 'total';
      // console.log("[chart-dateType]", dateType);
      switch (dateType) {
        // 日报表
        // case 'day':
        case 'date':
        default:
          param = {
            ...param,
            // this.datevalue
            year: this.chartDate.getFullYear(),
            month: this.chartDate.getMonth() + 1,
            day: this.chartDate.getDate(),
          }
          break;
        // 月报表
        case 'month':
          param = {
            ...param,
            // this.datevalue
            year: this.chartDate.getFullYear(),
            month: this.chartDate.getMonth() + 1,
          }
          break;
        // 年报表
        case 'year':
          param = {
            ...param,
            // this.datevalue
            year: this.chartDate.getFullYear(),
          }
          break;
        // 总报表
        case 'total':
          break;
        // 区间报表
        // case 'range':
        //   action = 'exportCollectorsData'
        //   param = {
        //     ...param,
        //     sdate: util.formatDate(this.datevalue[0]),
        //     edate: util.formatDate(this.datevalue[1])
        //   }
        //   break;
      }
      // 重复已注释
      this.$message.success(this.$t("report.download"));
      this.$request.get(action, param)
        .then((res) => {
          // 演示账号
          if (res.err) {
            this.$message.error(this.$t(`errCode.${res.err}`));
            return;
          } else {
            // console.log("[chart-exportOk]");
            // ......................
            window.location.href = this.$request.http_download_url_new(param)
            // this.closeDialog();
            // ......................
          }
          // this.$message.success(this.$t("report.download"));
        }).then(() => {
          // this.$message.success(this.$t("report.download"));
        }).catch((err) => {
          this.$message.error(err);
        });
    },
    // 查询图表数据 =====
    async queryData () {
      // 时间变量
      let date = this.currentCategoryVal.param.dateFormat
        ? this.$filter.formatDate1(
          this.chartDate,
          this.currentCategoryVal.param.dateFormat
        )
        : null,
        chartData = {
          category: [],
          data: [],
          unitX: ""
        };

      // 给X轴新加时间单位
      if (this.currentCategoryVal.datepickerType == "date") {
        chartData.unitX = "H"
      } else if (this.currentCategoryVal.datepickerType == "month") {
        chartData.unitX = "D"
      } else if (this.currentCategoryVal.datepickerType == "year") {
        chartData.unitX = "M"
      } else {
        chartData.unitX = "Y"
      }

      this.isLoading = true;

      // 过滤掉需要排除的参数
      let parameters = this.currentCategoryVal.param.parameter.filter(item => {
        if (!item.devcode) return true;
        return this.$store.state.device.devcode != item.devcode;
      });

      let requestParam = {
        pn: this.deviceInfo.pn,
        sn: this.deviceInfo.sn,
        devcode: this.deviceInfo.devcode,
        devaddr: this.deviceInfo.devaddr,
        i18n: this.$lang.currentLang,
        chartStatus: this.chartStatus.chartStatus,
        date
      };

      try {
        let res = await this.$request.getMicroserDess(
          this.currentCategoryVal.param.action,
          requestParam
        );

        let category = [];

        // 新接口结构：res.code === 0 && res.data.items
        if (res.code === 0 && res.data && res.data.items) {
          console.log(parameters,'parametersparameters');
          
          // 遍历返回的 items，每个 item 对应一个参数类型
          res.data.items.forEach((item, index) => {
            // 根据 type、typeCode 或 name 匹配对应的参数配置
            
            // typeCode 映射：0=PV_OUTPUT_POWER, 1=LOAD_ACTIVE_POWER, 2=BATTERY_ACTIVE_POWER, 3=GRID_ACTIVE_POWER, 5=负载功率
            let parameter = parameters.find(p => {
              // 通过 value 匹配 type
              // if (p.value === item.type) return true;
              // // 通过 name 匹配 type
              // if (p.name === item.type) return true;
              // 通过 typeCode 匹配（语言无关）
              if (item.typeCode !== undefined) {
                if (this.currentCategoryVal.chartType === 'line') {
                  // 折线图（日数据）typeCode 映射
                  const lineTypeCodeMap = {
                    0: 'GRID_ACTIVE_POWER',    // 买电功率
                    // 1: 卖电功率（暂无对应参数）
                    3: 'BATTERY_ACTIVE_POWER', // 充电功率
                    // 3: 放电功率（暂无对应参数）
                    4: 'PV_OUTPUT_POWER',      // 发电功率
                    5: 'LOAD_ACTIVE_POWER'     // 用电功率
                  };
                  if (lineTypeCodeMap[item.typeCode] === p.value) return true;
                } else {
                  // 柱状图（月/年/总数据）typeCode 映射
                  const barTypeCodeMap = {
                    0: ['ENERGY_TODAY_FROM_GRID', 'ENERGY_TOTAL_FROM_GRID'],       // 买电量
                    1: ['ENERGY_TODAY_TO_GRID', 'ENERGY_TOTAL_TO_GRID'],           // 卖电量
                    2: ['BATTERY_ENERGY_TODAY_CHARGE', 'BATTERY_ENERGY_TOTAL_CHARGE'],   // 充电量
                    3: ['BATTERY_ENERGY_TODAY_DISCHARGE', 'BATTERY_ENERGY_TOTAL_DISCHARGE'], // 放电量
                    4: ['ENERGY_TODAY', 'ENERGY_TOTAL'],                           // 发电量
                    5: ['LOAD_ENERGY_TODAY', 'LOAD_ENERGY_TOTAL']                  // 用电量
                  };
                  let matchValues = barTypeCodeMap[item.typeCode];
                  if (matchValues && matchValues.includes(p.value)) return true;
                }
              }
              return false;
            });
            if (!parameter) return;

            let dataItem = {
              name: parameter.name,
              value: []
            };

            if (this.currentCategoryVal.chartType === "bar") {
              // 月/年/总数据 - bar 图表
              category = this.currentCategoryVal.chartCategory;
              // 初始化值为 null
              dataItem.value = new Array(category.length).fill(null);

              if (item.vals && item.vals.length > 0) {
                item.vals.forEach(valItem => {
                  let formattedDate = this.$filter.formatDateSafe(
                    valItem.ts,
                    this.currentCategoryVal.chartFormat
                  );
                  // 处理 category 可能是数字数组的情况（如 "总" 类别）
                  let cindex = category.findIndex(c => String(c) === String(formattedDate));
                  if (cindex !== -1) {
                    let val = valItem.val;
                    if (val === null || val === undefined || val === "NaN") {
                      dataItem.value[cindex] = null;
                    } else if (!isNaN(val - 0)) {
                      dataItem.value[cindex] = parseFloat((val - 0).toFixed(3));
                    } else {
                      dataItem.value[cindex] = (val - 0).toFixed(3);
                    }
                  }
                });
              }
            } else if (this.currentCategoryVal.chartType === "line") {
              // 日数据 - line 图表
              if (item.vals && item.vals.length > 0) {
                // 找到最后一个有效数据的索引（从后往前找第一个非null非0的值）
                let lastValidIndex = item.vals.length - 1;
                for (let i = item.vals.length - 1; i >= 0; i--) {
                  let val = item.vals[i].val;
                  if (val !== null && val !== undefined && val !== "NaN" && (val - 0) !== 0) {
                    lastValidIndex = i;
                    break;
                  }
                }
                // 只截取到最后一个有效数据点
                let validVals = item.vals.slice(0, lastValidIndex + 1);
                validVals.forEach(valItem => {
                  let val = valItem.val;
                  if (!isNaN(val - 0)) {
                    dataItem.value.push(parseFloat((val - 0).toFixed(3)));
                  } else {
                    dataItem.value.push((val - 0).toFixed(3));
                  }
                });
                // 用最长的数据系列来设置 category（所有 item 时间戳相同，取最长的）
                if (validVals.length > category.length) {
                  category = validVals.map(v => v.ts);
                }
              }
            }

            chartData.data.push(dataItem);
          });

          chartData.category = category;
          this.chartData = chartData;

          // 过滤掉全为 0/null 的数据系列
          let numArr = [];
          for (let a = 0; a < this.chartData.data.length; a++) {
            for (let i = 0; i < this.chartData.data[a].value.length; i++) {
              let val = this.chartData.data[a].value[i];
              // 为负值时保留直接 push 进数组
              if (val < 0) {
                numArr.push(a);
                break;
              } else {
                if (Math.ceil(val) == "0") {
                  // 值为 0，跳过
                } else if (val == undefined || val == null) {
                  // undefined 或 null，跳过
                } else if (val == "NaN") {
                  // NaN，跳过
                } else {
                  numArr.push(a);
                  break;
                }
              }
            }
          }

          this.isLoading = false;
          let newChartData = [];
          newChartData.data = [];
          numArr.forEach(element => {
            newChartData.data.push(this.chartData.data[element]);
          });
          this.chartData.data = newChartData.data;

          // 检查是否有有效数据显示
          let arrTmp1 = [];
          let arrTmp2 = [];
          this.chartData.data.forEach((item) => {
            arrTmp1.push(item.value);
          });
          (arrTmp1.length > 0) && arrTmp1.forEach((item) => {
            arrTmp2.push(...item);
          });
          let flag = arrTmp2.some((item) => {
            return item != 0 && item != "NaN" && item != null;
          });
          this.showFlag = flag;

        } else {
          // 接口返回错误或无数据
          this.showFlag = false;
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        this.showFlag = false;
        console.error("查询图表数据失败:", error);
      }
    },
    // 切换上一天
    toPreDay () {
      // console.log("toPreDay");
      // console.log("[this.$refs.dateDay]", this.$refs.dateDay);
      // console.log("[this.$refs.dateDay.value]", this.$refs.dateDay.value);
      let aimTime = this.$filter.formatDate(this.$refs.dateDay.value, "yyyy-MM-dd");
      // console.log("aimTime", aimTime); // 2021-11-29
      let preDay = this.$tool.getYestoday(aimTime);
      if (/^\d{4}-\d{2}-\d{2}$/.test(preDay)) {
        const [y, m, d] = preDay.split('-');
        this.chartDate = new Date(Number(y), Number(m) - 1, Number(d));
      } else {
        this.chartDate = preDay;
      }
      // this.chartDate = preDay;
      // console.log("preDay", preDay); // 2021-11-28
    },
    // 切换下一天
    toNextDay () {
      let dayValue= new Date(this.$refs.dateDay.value)
      if (dayValue>Date.now()-8.64e7) return this.$message.warning(this.$t("device.noDate"));
      let aimTime = this.$filter.formatDate(this.$refs.dateDay.value, "yyyy-MM-dd");
      let nextDay = this.$tool.getNextday(aimTime);
      if (/^\d{4}-\d{2}-\d{2}$/.test(nextDay)) {
        const [y, m, d] = nextDay.split('-');
        this.chartDate = new Date(Number(y), Number(m) - 1, Number(d));
      } else {
        this.chartDate = nextDay;
      }
      // this.chartDate = nextDay;
    },
    // 切换上一月
    toPreMonth () {
      // console.log("[this.$refs.dateMonth.value]", this.$refs.dateMonth.value);

      let aimTime = this.$filter.formatDate1(this.$refs.dateMonth.value, "yyyy-MM-dd");
      // console.log("[aimTime]", aimTime);

      let preMonth = this.$tool.getPreMonth(aimTime);

      // console.log("[preMonth]", preMonth);
      // this.chartDate = preMonth;
      if (/^\d{4}-\d{2}$/.test(preMonth)) {
        const [y, m] = preMonth.split('-');
        this.chartDate = new Date(Number(y), Number(m) - 1);
      } else {
        this.chartDate = preMonth;
      }
    },
    // 切换下一月
    toNextMonth () {
      let aimTime = this.$filter.formatDate1(this.$refs.dateMonth.value, "yyyy-MM-dd");
      let nextMonth = this.$tool.getNextMonth(aimTime);
      if (new Date(nextMonth)>Date.now()) return this.$message.warning(this.$t("device.noDate"));
      // this.chartDate = nextMonth;
      if (/^\d{4}-\d{2}$/.test(nextMonth)) {
        const [y, m] = nextMonth.split('-');
        this.chartDate = new Date(Number(y), Number(m) - 1);
      } else {
        this.chartDate = nextMonth;
      }
    },
    // 切换上一年
    toPreYear () {
      // console.log("[this.$refs.dateYear.value]", this.$refs.dateYear.value);
      let aimTime = this.$filter.formatDate1(this.$refs.dateMonth.value, "yyyy-MM-dd");
      let preYear = this.$tool.getPreYear(aimTime);
      // console.log("[preYear]", preYear);
      // console.log("[new Date(preYear,0,1)]", new Date(preYear,0,1));
      this.chartDate = new Date(preYear, 0, 1);
    },
    // 切换下一年
    toNextYear () {
      // let aimTime = this.$filter.formatDate(this.$refs.dateYear.value, "yyyy");
      let aimTime = this.$filter.formatDate1(this.$refs.dateMonth.value, "yyyy-MM-dd");
      let nextYear = this.$tool.getNextYear(aimTime);
      let yearValue=nextYear + "-01-01" 
      if (new Date(yearValue)>Date.now()) return this.$message.warning(this.$t("device.noDate"));
      // console.log("[nextYear]", nextYear);
      // console.log("[new Date(nextYear,0,1)]", new Date(nextYear,0,1));
      this.chartDate = new Date(nextYear, 0, 1);
    },
  }
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

// .section{}
.deviceChartNew {
  position: relative;
  display: flex;
  flex-direction: column;
  border: none;
  box-shadow: none;
  padding: 0px;
  margin-top: 15px;
  background-color: rgb(34, 45, 53);

  .section-header {
    display: flex;
    align-items: center;
    // justify-content: flex-start;
    justify-content: space-between;
    border-bottom: 1px solid #7B8395;

    .tool {
      display: flex;
      align-items: center;

      .tiplabel {
        display: inline-block;
        color: #ffffff;
        padding: 0 15px;
        font-size: 14px;
      }

      .datepicker {
        margin-right: 15px;
      }

      // /deep/.el-date-editor.el-input {
      //   width: 150px;
      // }
      /deep/.el-date-editor.el-input .el-input__prefix {
        right: auto;
        left: 16px;
        font-size: 16px;
        color: #00FEBB;
      }

      /deep/.el-date-editor.el-input .el-input__inner {
        height: 46px;
        padding-left: 52px;
        background: transparent;
        color: #ffffff;
        border: none;
        border-radius: 0px;
        // border-left: 1px solid #7B8395;
        // border-right: 1px solid #7B8395;
      }

      /deep/.el-date-editor.el-input .el-input__suffix .el-input__icon:after {
        content: "";
        display: inline-block;
        position: absolute;
        top: 12px;
        right: -2px;
        height: 20px;
        width: 20px;
        background: url(../../../../assets/img/general/Icon_Down_Border.png) no-repeat;
        background-size: 100%;
        background-position: center;
      }

      // 时间图标
      /deep/.el-icon-date:before {
        content: "";
        display: inline-block;
        position: absolute;
        top: 12px;
        left: 0px;
        height: 24px;
        width: 24px;
        background: url(../../../../assets/img/general/Icon_Calendar.png) no-repeat;
        background-size: 100%;
        background-position: center;
      }

      .category {
        padding: 12px 10px;
        // border-radius: 20px;
        margin-left: 5px;
        .sc(14px, #7B8395);
        cursor: pointer;
        border: 1px solid transparent;

        &:hover {
          // border-color: @themeColor;
          // color: @themeColor;
          background: transparent;
          color: #00FEBB;
          border-bottom: 2px solid #00FEBB;
        }

        &.selected {
          // background: @themeColor;
          background: transparent;
          color: #00FEBB;
          border-bottom: 2px solid #00FEBB;
        }
      }

      // 日期盒子
      .datePreNext {
        padding: 0px 16px;
        border-left: 1px solid #7B8395;
        border-right: 1px solid #7B8395;

        /deep/.datepicker {
          margin: 0px;
          margin-right: 16px;
        }

        /deep/.el-date-editor.el-input {
          width: 150px;
        }

        /deep/.el-date-editor.el-input .el-input__inner {
          padding: 0px;
          text-align: center;
        }

        //.el-input__prefix,
        //.el-input__suffix
        /deep/.el-input__prefix {
          display: none;
        }

        /deep/.el-input__suffix {
          top: 2px;
          right: 16px;
        }

        .date-icon {
          display: inline-block;
          width: 24px;
          height: 24px;
          background: url(../../../../assets/img/general/Icon_Calendar.png);
          background-size: 100%;
          background-position: center;
          background-repeat: no-repeat;
          vertical-align: middle;
          margin-right: 16px;
        }

        .date-pre {
          background: url(../../../../assets/img/general/Chart_Date_Pre.png);
        }

        .date-next {
          background: url(../../../../assets/img/general/Chart_Date_Next.png);
        }

        .date-btn {
          color: #ffffff;
          cursor: pointer;
          display: inline-block;
          height: 16px;
          width: 16px;
          background-size: 100%;
          background-position: center;
          background-repeat: no-repeat;
          vertical-align: middle;
        }
      }
    }

    .exportClass {
      display: flex;
      flex-direction: row;
      height: 100%;

      .button-export {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 16px;
        // margin-right: 20px;
        // border-radius: 4px;
        // background: var(--theme-color);
        background: @primaryTextColor;
        color: rgb(34, 45, 53);
        font-size: 14px;
        cursor: pointer;

        .ico-download {
          width: 16px;
          height: 16px;
          background: url(../../../../assets/img/general/Icon_Download.png) no-repeat;
          background-size: 100%;
          background-position: center;
          margin-left: 10px;
        }
      }
    }
  }

  .section-chart {
    flex: 1;
  }

  .nodata {
    display: flex;

    .nodata1 {
      font-size: 14px;
      // line-height: 20px;
      color: #ffffff;
      opacity: 0.5;

    }

    .dataspan {
      // position: relative;
      // margin-left: 10px;
      // width: 480px;
      // height: 20px;

      // &:hover .dataspanTop {
      //   display: block;
      // }

      // &:hover .dataspanBom {
      //   display: block;
      // }

      .dataspanTop {
        width: 0;
        height: 0;
        border: 10px solid transparent;
        border-bottom-color: rgba(255, 255, 255, 0.7);
        top: 15px;
        position: absolute;
        display: none;
      }

      .dataspanBom {
        border-radius: 8px;
        background-color: #222d35;
        color: #ffffff;
        // padding: 8px;
        // font-size: 12px;
        // position: absolute;
        width: 480px;
        // left: -105px;
        // top: 35px;
        // opacity: 0.7;
        // display: none;
      }
    }
  }



}

.tableloding {

  // 加载数据时遮罩
  /deep/.el-loading-mask {
    background-color: rgb(34, 45, 53, .5);
  }

  /deep/.el-loading-spinner i {
    color: @primaryTextColor;
    font-size: 26px;
  }
}
</style>
<style lang="less">
// #时间选择器 el-date-picker#
.select-date {

  // 下拉
  &.el-date-picker {
    background: rgba(34, 45, 53, 1);
    border: none;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.48);
  }

  // 切换日 -----
  // 头部切换
  .el-date-picker__header {
    padding: 0px 50px;
  }

  .el-date-picker__header-label {
    color: rgba(238, 236, 241, 1);
  }

  // 前后切换
  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  // 一周
  .el-date-table th {
    color: rgba(238, 236, 241, 1);
    border: none;
  }

  // 日
  .el-date-table td div {
    padding: 0px;
  }

  .el-date-table td.today span {
    color: #00FEBB;
    font-weight: normal;
  }

  .el-date-table td.available {
    color: rgba(122, 117, 133, 1);
    font-size: 14px;
  }
  .el-date-table td.normal {
    // color: rgba(122,117,133, 0.2);
    font-size: 14px;
  }
  .el-date-table td.disabled div {
    color: rgba(122,117,133, 1) !important;
  }
  .el-month-table td.disabled .cell {
    background-color: rgba(34,45,53, 1);
  }
  .el-year-table td.disabled .cell {
    background-color: rgba(34,45,53, 1);
  }
  .el-date-table td.available:hover {
    color: #00FEBB;
  }

  .el-date-table td.current:not(.disabled) span {
    width: 30px;
    height: 30px;
    line-height: 26px;
    text-align: center;
    border-radius: 16px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    margin-top: -3px;
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: rgb(60, 56, 68);
    font-size: 16px;
  }

  // 切换月 -----
  .el-date-picker__header--bordered {
    border: none;
  }

  // 月
  .el-month-table td.today .cell {
    color: #00FEBB;
  }

  .el-month-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 32px;
  }

  .el-month-table td .cell {
    color: #7B8395;
  }

  .el-month-table td .cell:hover {
    color: #00FEBB;
  }

  // 切换年 -----
  // 年
  .el-year-table td.today .cell {
    color: #00FEBB;
  }

  .el-year-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 28px;
  }

  .el-year-table td .cell {
    color: #7B8395;
  }

  .el-year-table td .cell:hover {
    color: #00FEBB;
  }
}
</style>